export default __webpack_public_path__ + "static/media/m_foodieBooster07.d93f6f06.png";